import './style.less';

export default function () {
    return {
        link: (scope, element, attr) => {
            element.css({
                left: scope.spot.positionX + '%',
                top: scope.spot.positionY + '%'
            });
        },
        template: require('./view.html'),
        controller: ($rootScope) => {

            $rootScope.$on('categorySelected', (scope, data) => {
                for (let el of $rootScope.solutions) {
                    el.selected = !!el.category.find((id => {
                        return id == data.id;
                    }));
                }
            });

            $rootScope.$on('categoryClear', () => {
                for (let el of $rootScope.solutions) {
                    el.selected = false;
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/hot-spot/index.js